import { useState } from "react";
import Styles from "./Styles.module.css";
import dashboardclasses from "../../dashboard.module.css";
import { Services } from "../../../Services";
import { toast } from "react-toastify";

export default function Modal({
    setmodal,
    data,
    isAccepted,
    selectedDocument,
    getOrders,
}) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [reason, setReason] = useState(null);
    const CancelHandler = (e) => {
        e.stopPropagation();
        setmodal(false);
    };
    const submitHandler = (e) => {
        e.preventDefault();
        if (!isAccepted && !reason) {
            setError("Reject Reason is required");
            return;
        }
        let body = {
            driver_document_id: selectedDocument?.driver_document_id,
            is_document_verified: isAccepted ? 1 : 3,
            driver_id: data,
        };
        if (!isAccepted) {
            body = { ...body, reject_reason: reason };
        }
        const token = {
            Authorization: `token ${sessionStorage.getItem("token")}`,
        };
        setLoading(true);
        Services.ApproveRejectDocument("PATCH", JSON.stringify(body), token)
            .then((res) => {
                setLoading(false);
                console.log(res);
                setLoading(false);
                if (res.Status === 1) {
                    getOrders();
                    setmodal(false);
                    toast.success(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else if (res.Status === 0) {
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const openhandler = (e) => {
        e.stopPropagation();
    };
    return (
        <div
            className={dashboardclasses["return-modal"]}
            onClick={CancelHandler}>
            <div
                className={Styles["modal-content_approve"]}
                onClick={openhandler}
                style={{ width: "100%", height: "unset" }}>
                <h3>{isAccepted ? "Approve" : "Reject"} Document</h3>
                <form style={{ gap: "1rem" }} onSubmit={submitHandler}>
                    {isAccepted ? (
                        <p style={{ textAlign: "center" }}>
                            Are you sure you want to Approve ?
                        </p>
                    ) : (
                        <>
                            <div className={Styles["Form_control"]}>
                                <label htmlFor="">Reject Reason</label>
                                <textarea
                                    type="text"
                                    onChange={(e) => {
                                        setReason(e.target.value);
                                        setError(null);
                                    }}
                                />
                            </div>
                        </>
                    )}
                    {error && (
                        <p style={{ marginLeft: "0.3rem", color: "red" }}>
                            {error}
                        </p>
                    )}
                    <div className={Styles["act-btns"]}>
                        <button
                            type={"submit"}
                            style={{
                                backgroundColor: isAccepted ? "green" : "red",
                            }}
                            disabled={loading}
                            className={dashboardclasses["submit-btn"]}>
                            {loading
                                ? "...loading"
                                : isAccepted
                                ? "Approve"
                                : "Reject"}
                        </button>
                        <button type="button" onClick={CancelHandler}>
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
